// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingDots_root__8o4w0","dot":"LoadingDots_dot__kJynh","blink":"LoadingDots_blink__iunUN"};